import React from "react";

// import { Button } from "antd";

import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
// import ConvertUnitModal from "../ReportSpecs/ConvertUnitModal";
import {
  // applySpecManagerUnitConversion,
  // getSpecManagerUnitConversionSource,
  getUnitOptions,
} from "./Helper";
import MRLCountryList from "./MRLCountryList";
import SpecManagerSelect from "./SpecManagerSelect";
import SpecsQualitative from "./SpecsQualitative";
import SpecsQuantitative from "./SpecsQuantitative";
import SpecsRange from "./SpecsRange";

import { hasPermission, permissions } from "../../../../../utils/Permissions";

import { ReactComponent as MRLIcon } from "../../../../../assets/images/product/MRLIcon.svg";
import { ReactComponent as QualitativeIcon } from "../../../../../assets/images/product/QualitativeIcon.svg";
import { ReactComponent as QuantitativeIcon } from "../../../../../assets/images/product/QuantitativeIcon.svg";
import { ReactComponent as RangeIcon } from "../../../../../assets/images/product/RangeIcon.svg";
import { ReactComponent as SparkleIcon } from "../../../../../assets/images/product/specmanager/SuggestedSparkle.svg";
// import { ReactComponent as ArrowLeftRightFill } from "../../../../../assets/images/product/arrow-left-right-fill.svg";

import "../ReportSpecs/SampleTestResultTable.css";
import "./EditSpecTable.css";
import "../../../Product.css";

const isMrlRow = (item) => (
  Array.isArray(item.countries_lst)
  && item.countries_lst.length > 0
  && hasPermission(permissions.global.specialPesticides)
);

// Unit conversion is already built but disabled, as it is out of scope for the current Spec Manager flow.
// To enable it, uncomment the unit conversion code in this file.
// const isConvertibleTestType = (testType) => (
//   testType === "quantitative" || testType === "qualitative" || testType === "range"
// );

class EditSpecTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newQualitative: false,
      dismissedSuggestedTests: [],
      // showConvertUnitModal: false,
      // convertRowIndex: null,
    };
  }

  /**
   * Hide the Suggested badge once the user edits the suggested row
   * @param {Number} indexOfRowClicked index of the edited row
   * @param {String} fieldName field being updated
   * @param {*} newFieldValue new value for the field
   */
  dismissSuggestedSpec = (indexOfRowClicked, fieldName, newFieldValue) => {
    const { dataOfSpecEditing, suggestedSpecTests = [] } = this.props;
    const { dismissedSuggestedTests } = this.state;
    const row = dataOfSpecEditing[indexOfRowClicked];
    if (!row || !suggestedSpecTests.includes(row.test) || dismissedSuggestedTests.includes(row.test)) return;

    const [lowerBound, upperBound, unit] = row.specs || [];
    const typeChanged = fieldName === "test_type" && newFieldValue !== row.test_type;
    const specsChanged = fieldName === "specs"
      && (newFieldValue[0] !== lowerBound || newFieldValue[1] !== upperBound || newFieldValue[2] !== unit);
    if (typeChanged || specsChanged) {
      this.setState({ dismissedSuggestedTests: [...dismissedSuggestedTests, row.test] });
    }
  };

  /**
   * Show the Suggested badge only on the suggested Range row until the user edits it
   * @param {Object} item spec row
   * @returns {Boolean} true when the badge should be shown
   */
  showSuggestedBadge = (item) => {
    const { suggestedSpecTests = [] } = this.props;
    const { dismissedSuggestedTests } = this.state;
    return item.test_type === "range"
      && suggestedSpecTests.includes(item.test)
      && !dismissedSuggestedTests.includes(item.test);
  };

  handleDataChange = (indexOfRowClicked, fieldName, newFieldValue) => {
    const { dataOfSpecEditing, handleDataChange } = this.props;

    this.dismissSuggestedSpec(indexOfRowClicked, fieldName, newFieldValue);

    if (fieldName === "test_type") {
      if (dataOfSpecEditing[indexOfRowClicked].test_type !== newFieldValue) {
        dataOfSpecEditing[indexOfRowClicked].test_type = newFieldValue;
        dataOfSpecEditing[indexOfRowClicked].specs = [];

        if (newFieldValue === "qualitative") {
          this.setState({
            newQualitative: true,
          });
        }
      }
    } else if (fieldName === "specs") {
      dataOfSpecEditing[indexOfRowClicked][fieldName] = newFieldValue;
    } else if (fieldName === "countries_lst") {
      // Data update for pesticides
      dataOfSpecEditing.forEach((specEditingData, i) => {
        if (specEditingData.countries_lst) {
          dataOfSpecEditing[i].test_type = "";
          dataOfSpecEditing[i].specs = [];
          dataOfSpecEditing[i][fieldName] = newFieldValue;
        }
      });
    } else if (fieldName === "row") {
      dataOfSpecEditing[indexOfRowClicked] = newFieldValue;
    } else {
      dataOfSpecEditing.push({ [fieldName]: newFieldValue, test_type: "", specs: ["", "", ""] });
    }

    handleDataChange(dataOfSpecEditing);
  };

  // openConvertUnitModal = (rowIndex) => {
  //   const { dataOfSpecEditing } = this.props;
  //   const item = dataOfSpecEditing[rowIndex];
  //   const unit = item ? getSpecManagerUnitConversionSource(item).unit : "";
  //   if (!item || isMrlRow(item) || !unit) {
  //     return;
  //   }
  //   this.setState({
  //     showConvertUnitModal: true,
  //     convertRowIndex: rowIndex,
  //   });
  // };
  //
  // closeConvertUnitModal = () => {
  //   this.setState({
  //     showConvertUnitModal: false,
  //     convertRowIndex: null,
  //   });
  // };
  //
  // handleConvertUnitUpdate = ({ result, specs, unit }) => {
  //   const { convertRowIndex } = this.state;
  //   const { dataOfSpecEditing } = this.props;
  //   if (convertRowIndex == null || !dataOfSpecEditing[convertRowIndex]) {
  //     this.closeConvertUnitModal();
  //     return;
  //   }
  //
  //   const item = dataOfSpecEditing[convertRowIndex];
  //   const convertedValue = (result != null && String(result).trim() && String(result).trim() !== "-")
  //     ? result
  //     : specs;
  //   const nextRow = applySpecManagerUnitConversion(item, convertedValue, unit);
  //   this.handleDataChange(convertRowIndex, "row", nextRow);
  //   this.closeConvertUnitModal();
  // };
  //
  // renderUnitConversionButton = (item, rowIndex) => {
  //   if (isMrlRow(item) || !isConvertibleTestType(item.test_type)) {
  //     return null;
  //   }
  //
  //   const unit = getSpecManagerUnitConversionSource(item).unit;
  //   const isDisabled = !unit;
  //   const displayUnit = unit || "-";
  //
  //   return (
  //     <span className="productReportEditSpecTableUnitButtonWrap SampleTestResultTable__UnitButtonWrap">
  //       <Button
  //         type="default"
  //         className="SampleTestResultTable__UnitButton productReportEditSpecTableUnitButton"
  //         title={isDisabled ? "Select a unit to enable conversion" : displayUnit}
  //         disabled={isDisabled}
  //         onClick={(event) => {
  //           event.stopPropagation();
  //           if (!isDisabled) {
  //             this.openConvertUnitModal(rowIndex);
  //           }
  //         }}
  //       >
  //         <span className="SampleTestResultTable__UnitText TruncateText">
  //           {displayUnit}
  //         </span>
  //         <ArrowLeftRightFill className="SampleTestResultTable__UnitIcon" aria-hidden />
  //       </Button>
  //     </span>
  //   );
  // };

  renderSpecsControls = (item, rowIndex, unitOptions, newQualitative) => {
    if (isMrlRow(item)) {
      return (
        <MRLCountryList
          countriesData={item.countries_lst}
          onChange={(values) => this.handleDataChange(rowIndex, "countries_lst", values)}
          editMode
        />
      );
    }

    const specsData = item.specs.length === 0 ? ["", "", ""] : item.specs;
    const onSpecsChange = (newSpec) => this.handleDataChange(rowIndex, "specs", newSpec);

    if (item.test_type === "qualitative") {
      return (
        <SpecsQualitative
          data={specsData}
          handleDataChange={onSpecsChange}
          newQualitative={newQualitative}
          unitOptions={unitOptions}
        />
      );
    }
    if (item.test_type === "range") {
      return (
        <SpecsRange
          data={specsData}
          handleDataChange={onSpecsChange}
          unitOptions={unitOptions}
        />
      );
    }
    if (item.test_type === "quantitative") {
      return (
        <SpecsQuantitative
          data={specsData}
          handleDataChange={onSpecsChange}
          unitOptions={unitOptions}
        />
      );
    }

    return (
      <span className="productReportEditSpecTableSpecsDefaultValue">
        Please select test type to view the specs
      </span>
    );
  };

  render() {
    const {
      dataOfSpecEditing,
      unitOptions: unitOptionsProp,
    } = this.props;
    const unitOptions = getUnitOptions(unitOptionsProp);
    const {
      newQualitative,
      // showConvertUnitModal,
      // convertRowIndex,
    } = this.state;

    // const convertItem = convertRowIndex != null
    //   ? dataOfSpecEditing[convertRowIndex]
    //   : null;
    // const conversionSource = convertItem
    //   ? getSpecManagerUnitConversionSource(convertItem)
    //   : { value: "", unit: "" };

    return (
      <>
        <StyledScrollbar
          disableTrackYWidthCompensation
          disableTracksWidthCompensation
          className="productReportEditSpecTableScrollBar"
          id="specManagerEditSpecTableScrollBar"
        >
          <table className="specTable" id="productReportEditSpecTable">
            <thead>
              <tr>
                <th className="specManagerEditSpecTh1">Test</th>
                <th>Test Type</th>
                <th>Specs</th>
              </tr>
            </thead>
            <tbody>
              {dataOfSpecEditing.map((item, i) => (
                <tr key={i}>
                  <td className="productReportEditSpecTableTest">
                    {item.test}
                  </td>
                  <td className="productReportEditSpecTableTestType">
                    {isMrlRow(item) ? (
                      <div className="productReportEditSpecMRL">
                        <MRLIcon />
                        <span className="productReportEditSpecMRLText">MRL</span>
                      </div>
                    ) : (
                      <div className="productReportEditSpecTableTestTypeInner">
                        <SpecManagerSelect
                          width="152px"
                          optionSelected={item.test_type || undefined}
                          options={[
                            { value: "range", icon: <RangeIcon /> },
                            { value: "quantitative", icon: <QuantitativeIcon /> },
                            { value: "qualitative", icon: <QualitativeIcon /> },
                          ]}
                          placeholder="Choose Test Type"
                          onSelect={(optionSelected) => this.handleDataChange(i, "test_type", optionSelected)}
                        />
                        {this.showSuggestedBadge(item) && (
                          <span className="productReportEditSpecSuggestedBadge">
                            <SparkleIcon className="productReportEditSpecSuggestedBadgeIcon" aria-hidden />
                            Suggested
                          </span>
                        )}
                      </div>
                    )}
                  </td>
                  <td className="productReportEditSpecTableSpecs">
                    <div className="productReportEditSpecTableSpecsInner">
                      <div className="productReportEditSpecTableSpecsControls">
                        {this.renderSpecsControls(item, i, unitOptions, newQualitative)}
                      </div>
                      {/* {this.renderUnitConversionButton(item, i)} */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </StyledScrollbar>

        {/* {showConvertUnitModal && convertItem && (
          <ConvertUnitModal
            specOnly
            testName={convertItem.test}
            testCategory=""
            hasTestDetail={false}
            testDetailType=""
            currentResult="-"
            currentSpec={conversionSource.value || "-"}
            currentUnit={conversionSource.unit}
            specUnit={conversionSource.unit || "-"}
            testDate=""
            onClose={this.closeConvertUnitModal}
            onUpdateResult={this.handleConvertUnitUpdate}
            isSaving={false}
          />
        )} */}
      </>
    );
  }
}

export default EditSpecTable;
